import React from "react";
import { Spinner, Stack, Text } from "@chakra-ui/core";

export default () => (
  <Stack
    isInline
    spacing={4}
    align="center"
    justify="center"
    mt={8}
    width="100%"
    height="100%"
  >
    <Spinner
      thickness="4px"
      speed="0.65s"
      emptyColor="gray.200"
      color="blue.500"
      size="lg"
    />
    <Text fontWeight="500" fontSize="xl">
      {"Cargando mapa..."}
    </Text>
  </Stack>
);
